module.exports = __webpack_public_path__ + "static/leverage-tile-1c930495c5786640edc4732743c29d37.png";